module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "icon-color.ed42a466.png";